<template>
  <DBox
     :id="'settings-accounting-tax_groups'"
     :addButton="false"
     :addLink="true"
     :addLinkLabel="`${$t('add_new')} ${$t('vat_product_categories')}`"
     @add_click="onAddClick"
     :rightMenu="[
      {
        text: this.$t('vat_report'),
        value: 'vat_report'
      },
      {
        text: this.$t('load_default'),
        value: 'load_default'
      }
    ]"
    @menuClick="onRightMenuClick"
  >

    <DList
        :items="accountingSettingsData.vat_categories"
        :primaryKey="'vat_category_id'"
        :labelKey="'vat_category_name'"
        :clickable="true"
        @delete="onItemDelete"
        @item_click="onItemClick"
    />
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import { openModalRoute } from '../../../../dt-plugins/modal/modal.mixin';

export default {
  components: {
    DBox,
    DList
  },
  //props: ["selectedLabelDetails"],
    props: {
    accountingSettingsData: {
      type: Object,
      default: () => []
    },
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 27,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      }
    };
  },
  computed: {
    list: function() {
      return this.accountingSettingsData.vat_categories || [];
    },
  },
  methods: {
    onRightMenuClick: function(menu) {
      console.log(menu);
      if (menu == "load_default") {
        this.$emit("onLoadDefault");
      } else {
        this.$emit("onVatReport");
      }
    },
    onItemDelete:function(item){
      console.log("::::",item);
      const { vat_category_id } = item;

      this.$emit("delete", item);



    },
    onItemClick:function(item){
 
      openModalRoute(this, "vat_category_form", {
        mode: "edit",
        vat_category_id:item.vat_category_id
      });
    },  

    onSelectProduct: function(selectedCatalog) {
      this.$emit("selected", selectedCatalog.product_id);
    },

    onAddClick:function(){
      openModalRoute(this, "vat_category_form", {
        mode: "add"
      });
    }
  }
};
</script>
